export const AROMA_PACKAGE_ID = 24

export function resolveAromaTaskId (value) {
  const taskId = Number(value)
  return Number.isInteger(taskId) && taskId > 0 ? taskId : 119
}

export const AROMA_TASK_ID = resolveAromaTaskId(process.env.VUE_APP_AROMA_TASK_ID)
export const AROMA_DETAIL_IMAGE = 'https://bajie-sleep.oss-cn-hangzhou.aliyuncs.com/%E9%A6%99%E8%96%B0%E8%AF%A6%E6%83%85%E9%A1%B5.jpg'

export const PAY_THIRD_PARTY = {
  alipay: 1,
  wechat: 2
}

export function formatPrice (value) {
  const cents = Number(value)
  if (!Number.isFinite(cents)) return '-'
  return (cents / 100).toFixed(2)
}

export function filterCashiersForBrowser (cashiers = [], isWeixin = false) {
  const supported = isWeixin ? PAY_THIRD_PARTY.wechat : PAY_THIRD_PARTY.alipay
  return cashiers.filter(item => Number(item.thirdParty) === supported)
}

export function getPayType (cashier) {
  return Number(cashier?.thirdParty) === PAY_THIRD_PARTY.wechat ? 'wechat' : 'alipay'
}

export function formatPatientBirthday (value) {
  const birthday = String(value || '').trim()
  const date = birthday.match(/^\d{4}-\d{2}-\d{2}/)
  return date ? date[0] : birthday
}

export function buildAromaOrderPayload ({
  task,
  packageData,
  profile,
  shipping,
  cashierTypeId,
  jsCode = '',
  returnUrl
}) {
  return {
    hospitalId: task.hospitalId,
    doctorId: task.doctorId,
    cashierTypeId,
    jsCode,
    returnUrl,
    packageId: AROMA_PACKAGE_ID,
    freeTrial: 0,
    totalPackagePrice: packageData.packagePrice,
    payPrice: packageData.packagePrice,
    deposit: 0,
    depositSwitch: 0,
    discountSwitch: 0,
    discountAmount: 0,
    orderTaskId: AROMA_TASK_ID,
    patientName: profile.realName,
    patientBirthday: formatPatientBirthday(profile.birthday),
    patientSex: String(profile.sex) === '0' ? 1 : 2,
    patientMobile: profile.phoneNumber,
    patientAreaProvince: shipping.region[0],
    patientAreaCity: shipping.region[1],
    patientAreaDistrict: shipping.region[2],
    patientAddress: shipping.receiverAddress,
    receiverName: shipping.receiverName,
    receiverMobile: shipping.receiverMobile,
    receiverAreaProvince: shipping.region[0],
    receiverAreaCity: shipping.region[1],
    receiverAreaDistrict: shipping.region[2],
    receiverAddress: shipping.receiverAddress
  }
}

export function getOrderResultState (status) {
  if (Number(status) === 1) return { key: 'pending', title: '待支付', canPay: true }
  if (Number(status) === 2 || Number(status) === 3) {
    return { key: 'success', title: '支付成功!', canPay: false }
  }
  if (Number(status) === 4) return { key: 'closed', title: '订单已关闭', canPay: false }
  return { key: 'checking', title: '支付结果确认中', canPay: false }
}

export function buildPayResultUrl (origin, sn, orderId) {
  const url = new URL('/aroma-report/pay-result', origin)
  url.searchParams.set('sn', sn)
  if (orderId !== undefined && orderId !== null && orderId !== '') {
    url.searchParams.set('orderId', orderId)
  }
  return url.toString()
}
